import { Box, Typography } from '@mui/material';
import Image from 'next/image';
import React from 'react';
import { FooterProps } from './Footer.interface';
import classes from './Footer.module.scss';
const Footer: React.FC<FooterProps> = ({
  text = 'WellNow Urgent Care'
}) => {
  return <Box component="footer" className={classes.footer} data-sentry-element="Box" data-sentry-component="Footer" data-sentry-source-file="Footer.tsx">
			<Box className={classes.footerContainer} data-sentry-element="Box" data-sentry-source-file="Footer.tsx">
				<Image src={`${process.env.APP_PATH}/wellnow-logo-white.svg`} alt="Company Name" width={152} height={40} data-sentry-element="Image" data-sentry-source-file="Footer.tsx" />
				<Typography variant="bodySmallSemiBold" className={classes.copyRight} data-sentry-element="Typography" data-sentry-source-file="Footer.tsx">
					© {new Date().getFullYear()} {text}
				</Typography>
			</Box>
		</Box>;
};
export default Footer;